export const LAUNCH_DARKLY_CLIENT_SIDE_ID = '{<LAUNCH_DARKLY_CLIENT_SIDE_ID>}';
export const LAUNCH_DARKLY_DEV_CLIENT_SIDE_ID = '68ee64ac587627089fff4c63';
